import React from 'react';
import PropTypes from 'prop-types';

import H1 from './Typography/H1';
import Icon from './Icon';

const Logo = ({ style, iconStyle = {} }) => (
  <H1 style={{ position: 'relative', display: 'inline-block', ...style }}>
    <Icon name="logo" width="92px" height="26px" style={iconStyle} />
    {/* {!hideTag && (
      <span
        title="Still in development. Contains bugs and rough edges."
        style={{
          position: 'absolute',
          top: 0,
          right: '-50%',
          borderRadius: 20,
          backgroundColor: theme.colors.yellow,
          color: '#ffffff',
          padding: '3px 6px',
          fontSize: 10,
          fontWeight: '400',
          cursor: 'default',
        }}>
        beta
      </span>
    )} */}
  </H1>
);

Logo.propTypes = {
  // hideTag: PropTypes.bool,
  style: PropTypes.object,
  iconStyle: PropTypes.object,
};

export default Logo;
